import React, { useEffect, useRef } from "react";

export default function VideoThumbnail({ src, type = "video/mp4", className }) {
  const ref = useRef(null);

  useEffect(() => {
    const video = ref.current;
    if (!video) return;

    const onLoaded = () => {
      try {
        // Jump to a safe place where there’s usually a keyframe
        video.currentTime = 0.05;
      } catch {}
    };

    video.addEventListener("loadedmetadata", onLoaded);
    return () => video.removeEventListener("loadedmetadata", onLoaded);
  }, [src]);

  return (
    <video
      ref={ref}
      playsInline
      muted
      preload="metadata"
      controls={false}
      className={className}
    >
      <source src={src} type={type} />
    </video>
  );
}
